module.exports = __webpack_public_path__ + "img/tv-bg.4404f850.png";